/* ============
 * Country Module Mutations
 * ============
 */

import { FETCH_PACKAGING_MATERIALS } from '../../mutation-types';

export default {
  [FETCH_PACKAGING_MATERIALS](state, packagingMaterials) {
    state.all = packagingMaterials;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/packagingMaterial/mutations.js